<div class="py-[50px] px-[50px] bg-white">
    <div class="pb-10 flex items-center gap-5">
      <img
        class="w-[75px] h-[75px] rounded-full"
        [src]="'https://api.dicebear.com/9.x/glass/svg?seed=' + name"
        alt="profile"
      />
      <span class="text-[var(--darkPurple)] text-xl font-semibold">{{ name }}</span>
    </div>
  
    <div>
      <h6 class="text-[var(--darkPurple)] py-5 flex items-center gap-2">
        <i class="bx bxs-user"></i>
        Dados Cadastrais
      </h6>
  
      <ul class="flex gap-10 flex-wrap" id="user_data">
        <li>
          <label for="name">Nome</label>
          <input name="name" type="text" [(ngModel)]="name" />
        </li>
        <li>
          <label for="phone">Telefone</label>
          <input
            name="phone"
            type="text"
            [(ngModel)]="phone"
            class="disabled"
            disabled
          />
        </li>
        <li>
          <label for="email">Email</label>
          <input
            name="email"
            type="text"
            [(ngModel)]="email"
            class="disabled"
            disabled
          />
        </li>
      </ul>
    </div>
  
    <div>
      <h6 class="text-[var(--darkPurple)] py-5 flex items-center gap-2">
        <i class="bx bx-home-alt-2"></i>
        Dados de Endereços
      </h6>
  
      <ul class="flex gap-10 flex-wrap" id="user_data">
        <li>
          <label>CEP</label>
          <input type="text" [(ngModel)]="cep" />
        </li>
        <li>
          <label>Endereço</label>
          <input type="text" [(ngModel)]="address" />
        </li>
        <li>
          <label>Bairro</label>
          <input type="text" [(ngModel)]="district" />
        </li>
        <li>
          <label>UF</label>
          <input type="text" [(ngModel)]="UF" maxlength="2"/>
        </li>
      </ul>
    </div>
  
    <div class="py-[100px] flex gap-5 justify-center">
      <button
        class="border border-[#5C5E83] text-[#5C5E83] p-2 rounded-lg"
        (click)="ngOnInit()"
      >
        Descartar
      </button>
      <button
        class="bg-[--lightRed] text-white p-2 rounded-lg"
        (click)="saveChanges()"
      >
        Salvar
      </button>
    </div>
  </div>